<template>
	<div class="server-details flex gap-8
				m-lg:flex-col mx-5 wrap-anywhere">
		<div class="server-informations  flex flex-col gap-3 overflow-wrap
					m-lg:order-2">
			<h3>Server Details</h3>
			<table class="table-auto border-collapse w-full">
				<thead>
				<tr>
					<th class="col1"></th>
					<th class="col2"></th>
				</tr>
				</thead>
				<tbody>
				<tr>
					<td class="text-gray-950">
						SERVER IP
					</td>
					<td class="text-sm content-center">
						<IndexServerlistBadgesIPAddressBadge v-if="ip"
						                                     classes="min-w-max"
						                                     :ip="ip + port"
						                                     :platform="platform" tooltip-placement="bottom"/>
						<img v-else

						     src="/icons/loading.svg" alt="Loading"/>
					</td>
				</tr>
				<tr v-if="bedrockIP">
					<td class="text-gray-950">
						BEDROCK IP
					</td>
					<td class="text-sm content-center">
						<IndexServerlistBadgesIPAddressBadge
							:ip="bedrockIP + ':' + bedrockPort"
							tooltip-placement="bottom" :platform="platform"/>
					</td>
				</tr>
				<tr>
					<td class="text-gray-950">
						PLATFORM
					</td>
					<td class="text-sm w-fit content-center">
						<IndexServerlistBadgesServerPlatformBadge v-if="platform"
						                                          :platform="platform" :ip="ip + port"/>
						<img v-else
						     src="/icons/loading.svg" alt="Loading"/>
					</td>
				</tr>
				<tr v-if="uptime !== false">
					<td class="text-gray-950">
						VERSION
					</td>
					<td class="text-sm w-fit content-center">
						<div v-if="version"
						     class="flex bg-gray-250 h-fit text-black gap-2 text-sm p-1 px-2.5 rounded-xl w-fit break-word">
							<img src="/icons/cube.svg" alt="Server Platform Icon"
							     style="filter: brightness(0) saturate(100%)" width="16" height="16">
							{{ version }}
						</div>
						<img v-else
						     src="/icons/loading.svg" alt="Loading"/>
					</td>
				</tr>
				<tr>
					<td class="text-gray-950">
						PLAYERS
					</td>
					<td class="text-sm w-fit content-center">
						<IndexServerlistBadgesPlayersBadge v-if="uptime != null"
						                                   :uptime="uptime" :players="players"/>
						<img v-else
						     src="/icons/loading.svg" alt="Loading"/>
					</td>
				</tr>
				<tr v-if="websiteUrl !== undefined">
					<td class="text-gray-950">
						WEBSITE
					</td>
					<td class="text-sm w-fit content-center wrap-anywhere">
						<NuxtLink v-if="websiteUrl"
						          :to="websiteUrl"
						          target="_blank" external class="flex bg-gray-250 h-fit text-black gap-2 text-sm p-1 px-2.5 rounded-xl w-fit
									   hover:bg-gray-500">
							<img src="/icons/link.svg" alt="Server Platform Icon"
							     style="filter: brightness(0) saturate(100%)" width="16" height="16">
							{{
								websiteUrl
							}}
						</NuxtLink>
						<img v-else
						     src="/icons/loading.svg" alt="Loading"/>
					</td>
				</tr>
				<tr v-if="owner !== undefined">
					<td class="text-gray-950">
						OWNER
					</td>
					<td class="w-fit content-center text-gray-725">
						<template v-if="owner">
							{{ owner }}
						</template>
						<img v-else
						     src="/icons/loading.svg" alt="Loading"/>
					</td>
				</tr>
				<tr>
					<td class="text-gray-950 align-top">
						TAGS
					</td>
					<td class="text-sm flex gap-1 gap-y-1.5 w-full flex-wrap">
						<NuxtLink v-for="tag in tags"
						          :key="`tag-${tag}`"
						          :to="typeof tag === 'string' ? '' : {name: 'tag-page', params: {tag: tag.name}}"
						          class="bg-gray-150 px-2.5 py-1 text-gray-950 mr-1.5 rounded-2xl mbt-1.5 text-xs
								   hover:bg-gray-500">
							<template v-if="typeof tag === 'string'">
								{{ tag }}
							</template>
							<template v-else>
								{{ tag.name }}
							</template>
						</NuxtLink>
					</td>
				</tr>
				</tbody>
			</table>
			<div class="font-bold">Vote</div>
			<button class="text-white-0 bg-blue-500 py-1.5 flex justify-center gap-2 items-center rounded-lg
						   hover:bg-blue-800" @click="vote">
				<span>Vote for this server</span>
				<img alt="Arrow pointing to the right" src="/icons/right_arrow_small_white.svg" width="10" height="10">
			</button>

			<template v-if="(user && user.is_admin) || (usernameCookie && usernameCookie === server.user)">
				<div class="font-bold">Edit</div>
				<NuxtLink :to="'/server/' + server._id + '/edit'" class="edit-button  text-blue-500 border-2 border-blue-500 py-1.5 flex justify-center gap-2 items-center rounded-lg
							   hover:text-white-0 hover:bg-blue-500">
					<span>Edit</span>
					<img alt="Arrow pointing to the right" src="/icons/right_arrow_small_white.svg" width="10"
					     height="10">
				</NuxtLink>
			</template>
		</div>
		<div class="m-lg:order-1">
			<div>
				<div class="flex w-full items-center mb-4 gap-2">
					<img v-if="isFavicon && (server || serverCache)"
					     :src="serverCache ? '/api/server/' + id + '/favicon' : server.favicon"
					     alt="Server favicon" class="h-full" width="32"
					     height="64"/>
					<h1 class="text-2xl font-bold wrap-anywhere">{{ title }} Server IP</h1>
				</div>
				<h2 class="font-bold mb-2 mt-5">Description</h2>
				<p class="font-normal text-sm bg-gray-100 p-2.5 rounded-lg wrap-anywhere">
					<template v-for="(line, index) in splitDescription">
						<template v-if="index === splitDescription.length - 1 && !showFullDescription">
							<span class="font-normal">{{ line }}... </span>
						</template>
						<template v-else>
							{{ line }}
							<br v-if="index !== splitDescription.length - 1"/>
						</template>
					</template>
					<button v-if="!showFullDescription" @click="showFullDescription = true">READ MORE</button>
				</p>
			</div>
		</div>
		<div class="m-lg:order-3">
			<div class="flex gap-10 mt-3 m-lg:gap-5 m-lg:flex-wrap">
				<div class="place-items-center"
				     v-if="uptime">
					<h3 class="text-gray-950 text-sm">PLAYERS ONLINE</h3>
					<div class="flex mt-1 gap-1">
						<div class="text-2xl" :class="{'text-gray-850': players.origin === 'cache'}">{{ players.online }}</div>
					</div>
				</div>
				<div class="place-items-center">
					<h3 class="text-gray-950 text-sm">VOTES</h3>
					<div class="flex mt-1 gap-1">
						<div class="text-2xl">
							<template v-if="votes != null">
								{{ votes }}
							</template>
							<img v-else
							     src="/icons/loading.svg" alt="Loading"/>
						</div>
					</div>
				</div>
				<div class="place-items-center">
					<h3 class="text-gray-950 text-sm">UPTIME TODAY</h3>
					<div class="flex mt-1 gap-1">
						<div class="text-2xl">
							<template v-if="server">
								{{ server.history_data.uptime_today }}%
							</template>
						</div>
					</div>
				</div>
			</div>
			<div class="banner">
				<div v-if="isFavicon !== false" class="banner-image">
					<img v-if="isFavicon && (server || serverCache)"
					     :src="serverCache ? '/api/server/' + id + '/favicon' : server.favicon"
					     alt="Server favicon"
					     width="64" height="64"
					/>
				</div>
				<div class="banner-inner">
					<div v-if="server && server.status && server.status.description" class="banner-motd"
					     v-html="server.status.description"/>
				</div>
			</div>
			<div class="mt-5">
				<LazyServerPlayersChart :server="server"/>
			</div>
			<div class="mt-8">
				<FooterServerFAQ
					:title="title"
					:ip="ip"
					:port="port"
					:version="version"
					:tags="tags"
				/>
			</div>
		</div>
	</div>
</template>

<script setup>
import {notify} from "@kyvg/vue3-notification";

const serverCache = useState('serverPageCache', () => null)

const props = defineProps({
	openVote: Boolean,
})

defineComponent({
	name: "ServerPage"
});
const id = useRoute().params.id.split("-").slice(-1)[0];

const {data: server, status, refresh, clear} = await useLazyFetch("/api/server/" + id, {
	transform: (data) => {
		if (!data) {
			throw createError({
				statusCode: 404,
				statusMessage: "Server not found",
			});
		}
		if (data.status && typeof data.status.description === "string") {
			data.status.description = data.status.description.replace("§R", "\n");
			data.status.description = autoToHTML(data.status.description);
		}
		if (!data.description) {
			data.description = "";
		}

		return data;
	},
});

if (status.value === "error" || (status.value === "success" && (!server.value || !server.value.title || !server.value.ip))) {
	throw createError({
		statusCode: 410,
		statusMessage: 'This server does not exist',
	});
}

const user = useUser();
const usernameCookie = useCookie("username");

const ip = computed(() => {
	if (server.value) {
		return server.value.ip;
	} else if (serverCache.value) {
		return serverCache.value.ip;
	} else {
		return null;
	}
});

const bedrockIP = computed(() => {
	if (server.value && server.value.bedrock_ip && server.value.bedrock_status && server.value.bedrock_status.uptime) {
		return server.value.bedrock_ip;
	} else if (serverCache.value && serverCache.value.bedrock_ip && serverCache.value.bedrock_status && serverCache.value.bedrock_status.uptime) {
		return serverCache.value.bedrock_ip;
	} else {
		return null;
	}
});

const bedrockPort = computed(() => {
	if (server.value) {
		return server.value.bedrock_port;
	} else if (serverCache.value) {
		return serverCache.value.bedrock_port;
	} else {
		return null;
	}
});

const platform = computed(() => {
	if (server.value) {
		return getPlatform(server.value);
	} else if (serverCache.value) {
		return getPlatform(serverCache.value);
	} else {
		return null;
	}
});

const port = computed(() => {
	const port = server.value ? server.value.port : serverCache.value ? serverCache.value.port : null;
	if (port && port !== 25565) {
		return ":" + port;
	} else {
		return "";
	}
});

const version = computed(() => {
	if (server.value && server.value.status && server.value.status.version && server.value.status.version.name) {
		return server.value.status.version.name;
	} else if (serverCache.value && serverCache.value.status && serverCache.value.status.version && serverCache.value.status.version) {
		return serverCache.value.status.version;
	} else {
		return null;
	}
});

const uptime = computed(() => {
	if (server.value) {
		if (server.value.status) {
			return server.value.status.uptime;
		} else {
			return false;
		}
	} else if (serverCache.value) {
		if (serverCache.value.status) {
			return serverCache.value.status.uptime;
		} else {
			return false;
		}
	} else {
		return null;
	}
});

const players = computed(() => {
	if (server.value) {
		if (server.value.status && server.value.status.players) {
			return {
				origin: 'server',
				...server.value.status.players
			};
		} else {
			return false;
		}
	} else if (serverCache.value) {
		if (serverCache.value.status && serverCache.value.status.players) {
			return {
				origin: 'cache',
				...serverCache.value.status.players
			};
		} else {
			return false;
		}
	} else {
		return null;
	}
})

const websiteUrl = computed(() => {
	let res;
	if (server.value) {
		if (server.value.website_url) {
			res = server.value.website_url;
		} else {
			res = undefined;
		}
	} else if (serverCache.value) {
		if (serverCache.value.website_url) {
			res = serverCache.value.website_url;
		} else {
			res = undefined;
		}
	} else {
		res = null;
	}
	if (res) {
		res = "https://" + res.replace("https://", "").replace("http://", "").trim();
	}
	return res;
})

const owner = computed(() => {
	let owner = null;
	if (server.value || serverCache.value) {
		owner = server.value ? server.value.user : serverCache.value.user.username;
	}
	if (owner === 'optimus') {
		owner = undefined;
	}
	return owner;
});

const tags = computed(() => {
	if (server.value) {
		return server.value.tags;
	} else if (serverCache.value && serverCache.value.tags) {
		return serverCache.value.tags;
	} else {
		return [];
	}
});

const isFavicon = computed(() => {
	if (server.value) {
		return !!server.value.favicon;
	} else if (serverCache.value) {
		return serverCache.value.favicon;
	} else {
		return null;
	}
})

const title = computed(() => {
	let res;
	if (server.value) {
		res = server.value.title;
	} else if (serverCache.value) {
		res = serverCache.value.title;
	} else {
		res = null;
	}
	if (res) {
		res = res + (res.toLowerCase().includes("minecraft") ? "" : " Minecraft");
	}
	return res;
})

const votes = computed(() => {
	if (server.value) {
		return server.value.votes;
	} else if (serverCache.value) {
		return serverCache.value.votes;
	} else {
		return null;
	}
})

// // DESCRIPTION SPLIT and SHOW MORE

const showFullDescription = ref(server?.value?.description?.length > 450 || serverCache?.value?.description?.length > 450 ? false : true);

const splitDescription = computed(() => {
	let res;
	if (server.value) {
		res = server.value.description;
	} else if (serverCache.value) {
		res = serverCache.value.description.replace("<eNd>").replace(/\r\n|\n|\r/g, "<br>");
		if (res.endsWith("...")) {
			res = res.slice(0, -3);
		}
	}
	if (res) {
		if (showFullDescription.value) {
			res = res.trim().split(/<br ?\/?>|\\n/)
		} else {
			let visibleDescription = "";

			for (const word of res.trim().split(" ")) {
				if (visibleDescription.length + word.length < 450) {
					visibleDescription += word + " ";
				} else {
					break;
				}
			}

			res = visibleDescription.trim().split(/<br ?\/?>|\\n/);
		}
	}
	return res;
});

const userAgent = import.meta.server ? useRequestHeader("user-agent") : navigator.userAgent;

// Server-side rendering check
if (import.meta.server && isMobile(userAgent) && server.value.description.trim().length > 450) {
	showFullDescription.value = false;
} else if (!import.meta.server && isMobile(userAgent) && server.value.description.trim().length > 450) {
	showFullDescription.value = false;
}

// // END DESCRIPTION SPLIT and SHOW MORE

// const isFavourite = ref(false);
const viewTimeout = ref(null);

onMounted(async () => {
	if (props.openVote) {
		await vote();
	}

	const current = window.location.pathname;
	viewTimeout.value = setTimeout(() => {
		if (current !== window.location.pathname) {
			return;
		}
		$fetch("/api/server/" + id + "/view", {
			method: "POST",
			ignoreResponseError: true,
		});
	}, 3000);

	// try {
	// 	isFavourite.value = (await $fetch("/api/server/" + id + "/favourite")).favourite;
	// } catch (e) {
	// }
});

onUnmounted(() => {
	serverCache.value = null;
	if (viewTimeout.value) {
		clearTimeout(viewTimeout.value);
	}
});

// Currently not using, but keeping for future use

// const favourite = async () => {
// 	isFavourite.value = !isFavourite.value;
//
// 	const response = await $fetch("/api/server/" + id + "/favourite", {
// 		method: "POST",
// 		query: {
// 			inc: isFavourite.value,
// 		},
// 		ignoreResponseError: true,
// 	});
//
// 	if (response.status) {
// 		notify({
// 			type: "success",
// 			title: isFavourite.value ? "Listing added to favorites" : "Listing removed from favorites",
// 			text: isFavourite.value
// 				? "The listing has been successfully added to your favorites."
// 				: "The listing has been successfully removed from your favorites."
// 		})
// 	} else if (response.error) {
// 		notify({
// 			type: "error",
// 			title: "Unknown Error",
// 			text: response.error || "An error occurred while updating the listing."
// 		})
// 		isFavourite.value = !isFavourite.value;
// 	} else {
// 		notify({
// 			type: "error",
// 			title: "Unknown Error",
// 			text: "An unknown error occurred while processing your request. Please try again."
// 		})
// 		isFavourite.value = !isFavourite.value;
// 	}
// };

const {setPopup} = usePopup();

async function vote() {
	if (!server.value) {
		notify({
			type: "warn",
			title: "Page not loaded",
			text: "Please wait until the page is fully loaded before voting.",
		})
		return;
	}

	setPopup('VotePopup', {
		serverTitle: "<b>" + server.value.title + "</b>",
	});

	// add /vote to url
	if (!props.openVote) {
		await useRouter().push(`/server/${titleEncode(server.value.title, server.value.custom_title_url)}-${server.value._id}/vote`);
	}
}

useHead(() => {
	if (!server.value) {
		return;
	}
	return {
		link: [
			{
				rel: "canonical",
				href: `https://www.minecraftiplist.com/server/${encodeURI(
					titleEncode(server.value.title, server.value.custom_title_url))}-${server.value._id}`
			},
		]
	}
});

if (import.meta.server || server.value) {
	const encodedTitle = encodeHTML(server.value.title);
	useSeoMeta({
		title: `${server.value.title} Server IP - Minecraft IP List`,
		ogTitle: `${encodedTitle} Server IP - Minecraft IP List`,
		description: `All details for the Minecraft server ${encodedTitle}. Find the server IP Address, player count, server website, and server statistics here.`,
		ogDescription: `All details for the Minecraft server ${encodedTitle}. Find the server IP Address, player count, server website, and server statistics here.`,
		keywords: `${encodedTitle.toLowerCase()} minecraft server ip address, ${encodedTitle.toLowerCase()} minecraft server, join ${encodedTitle.toLowerCase()} minecraft server`,
		ogImage: isFavicon !== false ? "https://www.minecraftiplist.com/api/server/" + server.value._id + "/favicon" : ""
	});
}

useSeoMeta({
	title: () => server.value ? `${server.value.title} Server IP - Minecraft IP List` : "Loading..."
});
</script>

<style lang="scss" scoped>
@font-face {
	font-family: 'Minecraft';
	src: url('/fonts/Minecraft.ttf') format('truetype');
	font-weight: normal;
	font-style: normal;
	font-display: swap;
}

.col1 {
	min-width: 8em;
}

@media(min-width: 1024px) {
	.col1 {
		width: 60%;
		min-width: 8em;
	}

	.col2 {
		width: 100%;
	}
}

@media (max-width: 767px) {
	.col1 {
		width: 16%;
	}
}

.banner-motd {
	width: fit-content;
	margin: 0 auto;
	text-align: center;

	display: flex;
	flex-direction: column;

	// .motd-line
	& > * {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;

		& > * {
			font-family: Minecraft;
			font-size: 20px;
			min-width: 2px;
			line-height: 1.2;
			white-space: pre;

			@media (max-width: 768px) {
				font-size: 16px;
				line-height: 1;
			}

			@media (max-width: 480px) {
				font-size: 14px;
			}
		}
	}
}

table {
	td {
		padding-bottom: 1.25em;
	}

	tr > td:first-child {
		padding-right: 2em;

		@media (max-width: 768px) {
			padding-right: 1em;
		}
	}
}

.banner {
	margin-top: 1em;
	padding: 0 1em;

	background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAABVQTFRFIiIiGxsbHRYRFg8KLiEXJhsTHhUP7mNYCwAAAQFJREFUeNrsmDEOwzAMA92myf+fXMDqwOBAoXNELg1k2eeBsFSta+vYOkUVr+8DukSMlD5bK4ABgPph0trihpKL8HIBzAFwAy1L4/Y5AcwBuGV+q5Xd0cwMYA5AzcdUVxT7p/Bm0wDGAPrSqJdwx/0OlXIbwByAK3g84rXFa2kR1UgAEwBu2WH+kZo4gDkAmvW95dosffK0oLL1D2ACwG1jI+7aL8YDmAxwQ4RqpE7IHWprcgAPBfTjp36VBmXTH8AEAIeVNF/Z1JVGN/S8te8BPBrA1pyF0xnRja40J4AJAB0QcHDQt+Zs/WnfAOYANFX/2vXPWUXqcm41gAGArwADANYDrvGB0WJfAAAAAElFTkSuQmCC");
	background-repeat: repeat;

	//width: 912px;
	width: 100%;
	height: 108px;

	display: flex;
	gap: .5em;

	transition: none;
	position: relative;

	border-radius: 6px;

	@media (max-width: 912px) {
		width: 100%;
	}

	&:hover,
	&:focus {
		background: #000;

		&::after {
			content: "";
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			border: 3px solid #808080;
			box-sizing: border-box;
			border-radius: 6px;
		}
	}

	.banner-image {
		display: flex;
		align-items: center;

		min-width: 32px;

		@media (max-width: 768px) {
			max-width: 32px;
		}

		@media (min-width: 1200px) {
			min-width: 48px;
		}
	}

	.banner-inner {
		color: white;
		font-size: 1.2rem;
		display: flex;
		flex: 1;
		align-items: center;
	}
}

.edit-button {
	span {
		transition: all 50ms ease-in-out !important;
	}

	img {
		filter: brightness(0) saturate(100%) invert(39%) sepia(62%) saturate(4584%) hue-rotate(211deg) brightness(90%) contrast(96%);
	}

	&:hover {
		img {
			filter: none;
		}
	}
}

@media (min-width: 1024px) {
	.server-details {
		display: grid;
		grid-template-columns: 4fr 8fr;
		/* Two columns: one for 'x' and one for 'y' and 'z' */
		grid-template-rows: auto auto;
		/* Two rows: first row for 'x' and 'y', second row for 'x' and 'z' */
	}

	.server-details > div:nth-child(1) {
		grid-column: 1;
		/* x spans the first column */
		grid-row: span 2;
		/* x spans two rows */
	}

	.server-details > div:nth-child(2) {
		grid-column: 2;
		/* y is in the second column */
		grid-row: 1;
		/* y is in the first row */
	}

	.server-details > div:nth-child(3) {
		grid-column: 2;
		/* z is in the second column */
		grid-row: 2;
		/* z is in the second row */
	}
}

@media (max-width: 1440px) {
	.server-details {
		grid-template-columns: 5fr 8fr;
	}
}

@media (max-width: 1240px) {
	.server-details {
		grid-template-columns: 6fr 9fr;
	}
}
</style>